const initialState = {
  consent: { 
    form: {}, 
    submitted: false 
  },
  presurvey_form: {
    form: {},
    submitted: false,
  },
  postsurvey_form: {
    form: {},
    submitted: false,
  },
};

console.log(initialState);

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case "SIGNED_CONSENT_SUCCEEDED":
      return {
        ...state,
        consent: {
          ...state.consent,
          form: action.payload?.form || {},
          submitted: true,
        },
      };
    case "UPDATE_PRESURVEY_SELECTION_SUCCEEDED":
      return {
        ...state,
        presurvey_form: {
          ...state.presurvey_form,
          form: action.payload.form,
        },
      };
    case "SUBMIT_PRESURVEY_SUCCEEDED":
      return {
        ...state,
        presurvey_form: {
          ...state.presurvey_form,
          submitted: true,
        },
      };
    case "UPDATE_POSTSURVEY_SELECTION_SUCCEEDED":
      return {
        ...state,
        postsurvey_form: {
          ...state.postsurvey_form,
          form: action.payload.form,
        },
      };
    case "SUBMIT_POSTSURVEY_SUCCEEDED":
      return {
        ...state,
        postsurvey_form: {
          ...state.postsurvey_form,
          submitted: true,
        },
      };
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
}
